export default "__VITE_ASSET__Cnr0Xz6Z__"